import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPDsgn";

const ADPDsgnService = {
  async findAll(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`);
    return response.data;
  },

  async getItemById(designationCode: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${designationCode}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(designationCode: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${designationCode}`, item);
    return response.data;
  },

  async delete(designationCode: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${designationCode}`);
    return response.data;
  },

  async getDropdown(): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/get-dropdown`);
    return response.data;
  },
};

export default ADPDsgnService;

